import { ApiError } from './client';

/**
 * Shared error-message extraction for mutation `onError` handlers.
 *
 * admin-api emits RFC7807 problem+json (via ProblemJsonFilter), so the
 * human-readable message lives in `detail` — prefer it, then the legacy
 * `message` field, then the generic `ApiError` message (`api_error_<status>`).
 * Falls back to a caller-supplied default for non-API errors.
 */
export function parseMutationError(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    try {
      const parsed = JSON.parse(err.body) as { detail?: string; message?: string };
      return parsed.detail ?? parsed.message ?? err.message;
    } catch {
      return err.message;
    }
  }
  return fallback;
}
